class NwtGemsConfigDrawer extends HTMLElement {
  constructor() {
    super();

    this.state = {
      fabrics: {
        left: [],
        right: []
      },
      selected: {
        left: null,
        right: null
      },
      preloaded: {
        left: {},
        right: {}
      },
      variantIndex: 1,
      nwt_gems_vIdent_state: {
        prev: null,
        actual: null
      },
      previewGenerated:false,
      initialized: false
    };
  }

  connectedCallback() {
    this.productInfo = this.closest('product-info');
    this.canvas = this.querySelector("#nwt_gems_brain");
    this.ctx = this.canvas.getContext("2d");
    this.ctx.imageSmoothingEnabled = false;
    this.loadingOverlay = this.querySelector("#loading-overlay");
    this.leftGrid = this.querySelector("#left-grid");
    this.rightGrid = this.querySelector("#right-grid");
    this.overlay = this.querySelector(".nwt-gcd-overlay");
    this.closeBtn = this.querySelector("#nwt_gcd_close");
    this.gemsConfig = this.productInfo?.querySelector('nwt-gems-config')
    this.triggerOpen = this.gemsConfig?.querySelector('.nwt-gems-trigger');
    this.swapBtn = this.gemsConfig?.querySelector('#nwt-gems-swap');
    this.ctaBtn = this.querySelector('.nwt-gcd-cta');
    this.jsonPath = this.dataset.jsonUrl;
    this.dialog = this.dataset.dialog;
    this.atcBtn = this.productInfo?.querySelector('button.product-form__submit');
    this.selectedMedia = {};
    this.instanceId = this.productInfo.dataset.section || this.productInfo.dataset.productId;
    this.onVariantChangeUnsubscriber = undefined;
    this.fabricsReady = Promise.resolve();
    this.enable2For1 = this.dataset.enableOfferDuePerUno;
    this.monthsLabel = JSON.parse(this.productInfo?.querySelector('#nwt_months_label')?.textContent);
    try {
      this.variantsJson = JSON.parse(this.productInfo?.querySelector('#nwt_gems_config_script').textContent);      
    } catch (error) {}

    this.bindEvents();
  }


  bindEvents() {
    this.showCtaWarning(true);
    
    this.overlay.addEventListener("click", () => this.close());
    this.closeBtn.addEventListener("click", () => this.close());
    this.ctaBtn.addEventListener("click", async() => await this.handleSubmit());

    this.triggerOpen.addEventListener('click', () => this.open());
    this.swapBtn.addEventListener('click', () => this.open());
    this.bindVariantIndicatorsAtLoad();
    this.variantChangeTimeout = null;

    document.addEventListener('nwt_product:rendered', (event) => {
      if (event.detail.instanceId !== this.instanceId) return;

      this.handleVariantChange(event);
    });
  }

  bindVariantIndicatorsAtLoad() {
    // metodo eseguito subito al caricameto. assegna a prev e actual lo stesso indicatore
    // serve metodo che controlli variante attuale con una del json, quando trova corrispondendza salva l'indicatore
    const actualVid = this.findActualVariant();

    const indicator = this.findRelatedIndicator(actualVid);
    this.state.nwt_gems_vIdent_state.prev = indicator;
    this.state.nwt_gems_vIdent_state.actual = indicator;
    // console.log(this.state);
  }

  findRelatedIndicator(vid) {
    const found = this.variantsJson.find(a => a.vid === vid);
    if(!found) return;
    return found.nwt_gems_vIdent;
  }

  findActualVariant() {
    const script = this.productInfo.querySelector('script[data-selected-variant');
    if(!script) return;
    const vid = JSON.parse(script.innerText)?.id;
    return vid
  }

  handleVariantChange(evt) {
    console.log(evt);

    
    if(!evt.detail) return;
    this.needToChange = false;
    const selectedVid = evt.detail.vid.id;
    // console.log('variant-change', selectedVid,  this.variantsJson);

    const indicator = this.findRelatedIndicator(selectedVid);
    this.state.nwt_gems_vIdent_state.actual = indicator;
    if(this.state.nwt_gems_vIdent_state.actual != this.state.nwt_gems_vIdent_state.prev) {
      this.needToChange = true;
      console.log('variant-change', this.needToChange, this.state.nwt_gems_vIdent_state);
      this.changeSet(this.state.nwt_gems_vIdent_state.actual);
    }
  }

  changeSet(newIndicator) {
    // controllare se preview già stata generata o no.
    this.state.nwt_gems_vIdent_state.prev = this.state.nwt_gems_vIdent_state.actual;
    this.state.nwt_gems_vIdent_state.actual = newIndicator;
    
    let isPreviewGenerated = this.state.previewGenerated;
    console.log('--------- changeSet ', isPreviewGenerated);

    if(isPreviewGenerated) {
      this.indicatorUpdatePreview(newIndicator).then(() => {
        // console.log("preview aggiornata");
      });
    }
    else this.regenerateSelectors(newIndicator).then(() => {});
  }

  async indicatorUpdatePreview(newIndicator) {
    try {
      const variantMatch = this.variantsJson.find(
        v => v.nwt_gems_vIdent === newIndicator
      );

      if (!variantMatch) return;

      const variantIdentifier =
        variantMatch.nwt_gems_vIdent;

      // aggiorna stato identità
      this.state.nwt_gems_vIdent_state.actual = newIndicator;

      // reload fabrics basato su IDENTIFIER
      console.log('--------',variantIdentifier);
      
      // this.state.fabrics = await this.loadFabrics(variantIdentifier);
      this.fabricsReady = this.loadFabrics(variantIdentifier);

      const fabrics = await this.fabricsReady;

      this.state.fabrics = fabrics;
      // reset selezioni
      // this.state.selected.left = this.state.fabrics.left?.[6]?.id ?? null;
      // this.state.selected.right = this.state.fabrics.right?.[4]?.id ?? null;

      // render UI
      this.renderGrid("left");
      this.renderGrid("right");
      this.updateGridSelection("left");
      this.updateGridSelection("right");

      // preload + draw
      await this.preloadAllImages();
      this.draw();

      const base64 = await this.export64(this.canvas);
      this.updatePreview(base64);
      this.prepareFormInputs(base64);

      this.state.previewGenerated = true;

    } catch (err) {
      console.error("indicatorUpdatePreview error:", err);
    }
  }

  async regenerateSelectors(newIndicator) {
    try {
      const variantMatch = this.variantsJson.find(
        v => v.nwt_gems_vIdent === newIndicator
      );

      if (!variantMatch) return;

      const variantIdentifier =
        variantMatch.nwt_gems_vIdent;

      // aggiorna stato identità
      this.state.nwt_gems_vIdent_state.actual = newIndicator;

      // reload fabrics basato su IDENTIFIER
      console.log('--------regenerateSelectors ',variantIdentifier);
      
      // this.state.fabrics = await this.loadFabrics(variantIdentifier);
      this.fabricsReady = this.loadFabrics(variantIdentifier);

      const fabrics = await this.fabricsReady;

      this.state.fabrics = fabrics;
      // reset selezioni
      // this.state.selected.left = this.state.fabrics.left?.[6]?.id ?? null;
      // this.state.selected.right = this.state.fabrics.right?.[4]?.id ?? null;

      // render UI
      this.renderGrid("left");
      this.renderGrid("right");
      this.updateGridSelection("left");
      this.updateGridSelection("right");
      await this.preloadAllImages();
      this.draw();


    } catch (err) {
      console.error("indicatorUpdatePreview error:", err);
    }
  }



  showCtaWarning(show) {
  const productInfo = this.closest('product-info');
  if (!productInfo || !this.atcBtn) return;

  // console.log('show warning ', show);

  // crea listener UNA SOLA VOLTA
  if (!this.onProductRendered) {
    this.onProductRendered = (event) => {
      if (event.detail.instanceId !== this.instanceId) return;

      this.atcBtn.disabled = true;
    };
  }

  if (show === true) {

    document.addEventListener(
      'nwt_product:rendered',
      this.onProductRendered
    );

    if (!this.atcBtn.querySelector('.gcd-atc-blocked')) {
      const span = document.createElement('span');
      span.classList.add('alt-font', 't-center', 'gcd-atc-blocked');
      span.innerText = this.dataset.atcLabel;

      this.atcBtn.appendChild(span);
    }

    this.atcBtn.classList.add('flex-col', 'align-it-center');
    this.atcBtn.disabled = true;

  } else {

    document.removeEventListener(
      'nwt_product:rendered',
      this.onProductRendered
    );

    const span = this.atcBtn.querySelector('.gcd-atc-blocked');

    this.atcBtn.disabled = false;
    this.atcBtn.classList.remove('flex-col', 'align-it-center');

    if (span) span.remove();
  }
}



  async open() {
    this.classList.add("is-open");

    if (!this.state.initialized) {
      await this.init();
    }
  }

  close() {
    this.classList.remove("is-open");
  }

  async loadFabrics(variantIdentifier) {
    const res = await fetch(this.jsonPath);

    if (!res.ok) {
      throw new Error("Errore caricamento json");
    }

    const json = await res.json();

    const config = json.gemsConfig.find(
      (item) =>
        item.gemsConfig_variant_identifier === variantIdentifier
    );
    console.log('loadFabrics', variantIdentifier);
    
    if (!config) {
      throw new Error(
        `Config non trovata per identifier: ${variantIdentifier}`
      );
    }

    // console.log('----- loadFabrics ', config.matches);
    

    return config.matches;

  }

  async handleSubmit() {
    const validated = this.isValidated();
    if(!validated) return;

    await this.fabricsReady;

    this.selectedMedia.leftImg = [...this.querySelectorAll('.fabric-grid input.nwt-gcd-inpt:checked')][0].dataset.prevImgUrl;
    this.selectedMedia.leftName = [...this.querySelectorAll('.fabric-grid input.nwt-gcd-inpt:checked')][0].dataset.imgName;
    this.selectedMedia.rightImg = [...this.querySelectorAll('.fabric-grid input.nwt-gcd-inpt:checked')][1].dataset.prevImgUrl;
    this.selectedMedia.rightName = [...this.querySelectorAll('.fabric-grid input.nwt-gcd-inpt:checked')][1].dataset.imgName;
    this.selectedMedia.canvas = this.querySelector('#nwt_gems_brain');
    this.state.previewGenerated = true;
    this.handleFinalizing();
  }


  handleFinalizing() {
    this.export64(this.selectedMedia.canvas)
      .then(base64 => {
        this.showCtaWarning(false);
        this.close();
        this.updatePreview(base64);
        this.prepareFormInputs(base64);
        // console.log(this.state);
        
      })
      .catch(err => console.error(err));
  }

  updatePreview(base64) {
    const preview = this.gemsConfig.querySelector('.nwt-gems-preview');
    if(!preview) return;

    const l = preview.querySelector('#nwt-gems-prev-label_left');
    const r = preview.querySelector('#nwt-gems-prev-label_right');
    const img = preview.querySelector('#nwt_gems_prev_image');

    if(!l || !r || !img) return;

    l.innerText = this.selectedMedia.leftName;
    r.innerText = this.selectedMedia.rightName;
    img.src = base64;

    preview.classList.remove('hidden');
    this.triggerOpen.classList.add('hidden');
  }

  prepareFormInputs(base64) {
    const nativeInpts = [...document.querySelectorAll('.nwt-gcd-hid-inpt')];
    if (nativeInpts.length < 2) return;

    nativeInpts[0].value = this.selectedMedia.leftName;
    nativeInpts[1].value = this.selectedMedia.rightName;

    const file = this.dataURLtoFile(base64, "preview.webp");

    const dt = new DataTransfer();
    dt.items.add(file);
    nativeInpts[2].files = dt.files;

    // console.log(nativeInpts[3],this.enable2For1,nativeInpts[3]?.classList.contains('nwt-gcd-hid-inpt_qty'));
    if(this.enable2For1 && nativeInpts[3]?.classList.contains('nwt-gcd-hid-inpt_qty')) {
      nativeInpts[3].setAttribute('value', 2);
      // console.log(nativeInpts[3]);
      
    }
  }

  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }



  export64(canvas) {
    return new Promise((resolve, reject) => {
      if (!(canvas instanceof HTMLCanvasElement)) {
        reject(new Error('Il parametro deve essere un HTMLCanvasElement.'));
        return;
      }

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Impossibile esportare il canvas.'));
            return;
          }

          const reader = new FileReader();

          reader.onloadend = () => {
            resolve(reader.result); // Data URL Base64
          };

          reader.onerror = reject;

          reader.readAsDataURL(blob);
        },
        'image/webp',
        0.3 // qualità 80%
      );
    });
  }



  isValidated() {
    const selectedInputs = [...this.querySelectorAll('.fabric-grid input.nwt-gcd-inpt:checked')];
    const sets = this.querySelectorAll('.fabric-grid');
    

    if(selectedInputs.length == 2) {
      [...sets].forEach(set => {
        this.hideDialogMess(set)
      });
      return true;
    } else {

      
      const notSelectedSets = [];

      [...sets].forEach(set => {
        const hasSettedInput = set.querySelector('input.nwt-gcd-inpt:checked');
        if(!hasSettedInput) {
          this.showDialogMess(set.closest('.selector-block')) 
        }
        
      });

      // bisogna ottenere i set che non contengono input selezionati, si fa confrontando dentro oguno, oppore utilizzando variabile di prima.



      return false;
    }
  }


  showDialogMess(set) {
    set.querySelector('.dialog-mes')?.classList.add('show');
  }

  hideDialogMess(set) {
    set.querySelector('.dialog-mes')?.classList.remove('show');
  }


  preloadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.crossOrigin = "anonymous";

      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }

  async preloadAllImages() {
    const tasks = [];

    ["left", "right"].forEach((side) => {
      this.state.preloaded[side] = {};

      this.state.fabrics[side].forEach((item) => {
        tasks.push(
          this.preloadImage(item.image).then((img) => {
            this.state.preloaded[side][item.id] = img;
          })
        );
      });
    });

    await Promise.all(tasks);
  }

  renderGrid(side) {
    const container = side === "left"
      ? this.leftGrid
      : this.rightGrid;

    container.innerHTML = "";

    this.state.fabrics[side].forEach((item, index) => {
      const el = document.createElement("label");

      el.className = "fabric-item";
      el.dataset.id = item.id;
      el.htmlFor = `nwt-gcd-inpt-${side}-${item.id}`

      el.innerHTML = `
        <img
          class="fabric-thumb"
          src="${item.prevImg}"
          alt="${this.monthsLabel[index] || item.label}"
        >
        <span class="fabric-label" data-generated-label="${this.monthsLabel[index]}">
          ${this.monthsLabel[index] || item.label}
        </span>
        <input type="radio" name="nwt-gcd-input-${side}" ${(side === "left" && index === 6) || (side === "right" && index === 4) ? 'checked' : ''} class="nwt-gcd-inpt" id="nwt-gcd-inpt-${side}-${item.id}" data-prev-img-url="${item.prevImg}" data-img-name="${this.monthsLabel[index] || item.label}">
      `;

      el.addEventListener("click", () => {
        this.selectFabric(side, item.id);
      });

      container.append(el);
    });
  }

  updateGridSelection(side) {
    const container = side === "left"
      ? this.leftGrid
      : this.rightGrid;

    container.querySelectorAll(".fabric-item").forEach((el) => {
      el.classList.toggle(
        "selected",
        Number(el.dataset.id) === this.state.selected[side]
      );
    });
  }

  selectFabric(side, id) {
    this.state.selected[side] = id;

    this.updateGridSelection("left");
    this.updateGridSelection("right");

    this.draw();
  }

  draw() {
    this.ctx.clearRect(0,0,this.canvas.width,this.canvas.height );

    const left = this.state.preloaded.left[this.state.selected.left];
    const right = this.state.preloaded.right[this.state.selected.right];

    if (left) {
      this.drawImage(left);
    }

    if (right) {
      this.drawImage(right);
    }
  }

  drawImage(img) {
    this.ctx.drawImage(
      img,
      0,
      0,
      this.canvas.width,
      this.canvas.height
    );
  }

  async init() {
    try {
      this.loadingOverlay.classList.remove("hidden");

      const variantIdentifier =
      this.state.nwt_gems_vIdent_state.actual;

      // this.state.fabrics = await this.loadFabrics(variantIdentifier);

      this.fabricsReady = this.loadFabrics(variantIdentifier);

      const fabrics = await this.fabricsReady;

      this.state.fabrics = fabrics;

      this.state.selected.left = fabrics.left[6].id;
      this.state.selected.right = fabrics.right[4].id;

      // this.state.selected.left = this.state.fabrics.left[6].id;
      // this.state.selected.right = this.state.fabrics.right[4].id;
      this.renderGrid("left");
      this.renderGrid("right");
      this.updateGridSelection("left");
      this.updateGridSelection("right");

      await this.preloadAllImages();

      this.draw();
      this.loadingOverlay.classList.add("hidden");
      this.state.initialized = true;

    } catch (e) {
      console.error(e);

      this.loadingOverlay.querySelector("span").textContent =
        "Errore nel caricamento";
    }
  }
}

customElements.define(
  "nwt-gems-config-drawer",
  NwtGemsConfigDrawer
);